<div [ngClass]="oscCodes.includes(gdSession?.oscConfig?.oscCode) ? 'tofel-modal-header' : 'modal-header'" tabindex="0" *transloco="let t">
    <h3 mat-dialog-title [ngClass]="oscCodes.includes(gdSession?.oscConfig?.oscCode) ? 'tofel-dialog-title' : 'mat-mdc-dialog-title mdc-dialog__title'">
        {{t('paybybank')}}
    </h3>
    <button mat-icon-button class="close-button" aria-label="Close modal" (click)="exit()" role="button" tabindex="0">
        <mat-icon class="close-icon" aria-hidden="true">close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <p *transloco="let t">{{t('paybybank.popup.info.text.part1')}}
        <br/>{{t('paybybank.popup.info.text.part2')}}<br/>
        {{t('paybybank.popup.info.text.part3')}}
     </p>
</mat-dialog-content>
